import axios from 'axios';

export const fetchAccount = () => axios.get('/account');
export const updateAccount = data => axios.put('/account', data);
